import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import { FaPeopleGroup } from 'react-icons/fa6';
import * as Motion from 'motion/react';
import DashboardList, { DashboardLeagueListRenderComponent } from '../../components/DashboardList';
import Loader from '../../components/Loaders';
import useDialogBox from '../../hooks/useDialogBox';
import { createLeague, getLeagues } from '../../api/v1/leagues';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Leagues = () => {
  const formRef = useRef(null);
  const [leagues, setLeagues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { resetDialogBox, setDialogBox } = useDialogBox();

  const loadLeagueList = async () => {
    const result = await getLeagues();

    setLeagues(result?.data);
  };

  const createLeagueSubmit = async () => {
    const { displayName, leagueDescription, leagueSlug } = formRef.current?.getValues();

    if (!displayName.length) {
      alert('Please enter league name');
    }
    else if (!leagueSlug.length) {
      alert('Please enter league slug');
    }
    else if (!leagueDescription.length) {
      alert('Please enter league description');
    }
    else {
      await createLeague({
        displayName: displayName,
        leagueDescription: leagueDescription,
        leagueSlug: leagueSlug,
      });

      resetDialogBox();

      await loadLeagueList();
    }
  };

  const newLeague = async () => {
    setDialogBox({
      title: 'Add League',
      content: <AddLeagueForm ref={formRef}/>,
      actions: [
        { title: 'Create League', type: 'primary', action: () => createLeagueSubmit() },
        { title: 'Cancel', type: 'cancel', action: () => resetDialogBox() }
      ]
    });
  };

  useEffect(() => {
    (async () => {
      await loadLeagueList();
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <div>
            <h2 className="screen-title">
              <FaPeopleGroup/>
              Leagues
            </h2>
          </div>
        </div>

        <button className="screen-header-button primary" onClick={() => newLeague()}>
          <FaPlusCircle/>Add League
        </button>
      </motion.div>

      <DashboardList items={leagues} RenderComponent={DashboardLeagueListRenderComponent}/>

    </>
  )
};


const AddLeagueForm = forwardRef((props, ref) => {
  const [displayName, setDisplayName] = useState('');
  const [leagueDescription, setLeagueDescription] = useState('');
  const [leagueSlug, setLeagueSlug] = useState('');

  const getValues = () => {
    return { displayName, leagueDescription, leagueSlug };
  };

  useImperativeHandle(ref, () => ({
    getValues,
  }));

  return (
    <div className="modal-form">
      <div className="form-group">
        <label>League Name</label>
        <input placeholder="League Name" value={displayName}
               onChange={(e) => setDisplayName(e.target.value)}/>
      </div>

      <div className="form-group">
        <label>League Slug</label>
        <input placeholder="League Slug" value={leagueSlug} onChange={(e) => setLeagueSlug(e.target.value)}/>
      </div>

      <div className="form-group">
        <label>Description</label>
        <input placeholder="League Description" value={leagueDescription}
               onChange={(e) => setLeagueDescription(e.target.value)}/>
      </div>
    </div>
  );
});

export default Leagues;
